import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import { getCommissionSettings } from "../../../MyApi/comissonsettings";
import { commissionSettingsColumns } from "../financialData";
import Can from "../../../utils/can";
import FilterBar from "../../../Components/UI/filterbar";

const CommissionSettingsTab = () => {
  const [currentCommisonSettings, setCurrentCommisonSettings] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    store_id: "",
    category_id: "",
    date: ""
  });

  const { data: commissionData, isLoading: loadingCommissions ,isFetching ,error ,refetch} = useQuery(
    ["getCommissionSettings", filters, currentCommisonSettings],
    () => getCommissionSettings(currentCommisonSettings, filters)
  );

  const commissions = commissionData?.data?.commission_stores || [];
  const last_pageCommissons = commissionData?.data?.pagination?.last_page || 0;
  const totalCommissons = commissionData?.data?.pagination?.total || 0;

  const handleFilterChange = (newFilters) => {
    setCurrentCommisonSettings(1); // Reset to first page when filters change
  };

  const handleResetFilters = () => {
    setFilters({
      search: "",
      store_id: "",
      category_id: "",
      date: ""
    });
    setCurrentCommisonSettings(1);
  };

  const filtersConfig = {
    search: true,
    store: true,
    categories: true,
    date: true
  };

  return (
    <Can permission={"view_store"}>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        filtersConfig={filtersConfig}
        placeholder="البحث حسب اسم المتجر..."
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
      />
      <DataTable
        columns={commissionSettingsColumns}
        data={commissions || []}
        title="إعدادت العمولة"
        isLoading={loadingCommissions}
        currentPage={currentCommisonSettings}
        setCurrentPage={setCurrentCommisonSettings}
        totalItems={totalCommissons}
        itemsPerPage={last_pageCommissons}
        isFetching={isFetching}
        error={error}
        onRetry={refetch}
      />
    </Can>
  );
};

export default CommissionSettingsTab;
